import React from 'react';
import { Button, Box, Typography } from '@mui/material';  // Import MUI components
import { Link } from 'react-router-dom';  // For navigation
import backgroundImage from '../images/bild5.png';  // Import image

const Home = () => {
  return (
    <Box
      sx={{
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: 0,
        minHeight: '100vh',
        overflow: 'hidden',
      }}
    >
      {/* Bakgrundsbild */}
<Box
  sx={{
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: '#D3D3D3', // Valfri ljus bakgrund
    backgroundImage: `url(${backgroundImage})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: {
      xs: '180%',   // 📱 Liten skärm – större bild
      sm: '120%',   // 🧑‍💻 Mellanstor
      md: '120%',   // 💻 Normal desktop
      lg: '80%',    // 🖥️ Stor skärm
    },
    zIndex: -1,
  }}

/>





      <Link to="/productlist" style={{ textDecoration: 'none' }}>
        <Button
          variant="contained"
          sx={{
            padding: '10px 20px',
            fontSize: '1rem',
            backgroundColor: '#333', // Mörkgrå färg
            color: 'white',
            borderRadius: '5px',
            boxShadow: 2,
            '&:hover': {
              backgroundColor: '#000', // Svart vid hover
            },
          }}
        >
          Utforska våra produkter
        </Button>
      </Link>
    </Box>
  );
};

export default Home;
